import { render, staticRenderFns } from "./SupportStatusFilter.vue?vue&type=template&id=63114ff4&scoped=true&"
import script from "./SupportStatusFilter.vue?vue&type=script&lang=ts&"
export * from "./SupportStatusFilter.vue?vue&type=script&lang=ts&"
import style0 from "./SupportStatusFilter.vue?vue&type=style&index=0&id=63114ff4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63114ff4",
  null
  
)

export default component.exports